// src/components/Design/FloorViewerHelpBannerContainer.tsx (justera path efter din struktur)
import React from "react";
import { Box, Stack } from "@mantine/core";

interface FloorViewerHelpBannerContainerProps {
  children: React.ReactNode;
}

export const FloorViewerHelpBannerContainer: React.FC<FloorViewerHelpBannerContainerProps> = ({
  children,
}) => {
  return (
    <Box
      // Viktigt: absolut position i botten, centrerad
      style={{
        position: "absolute",
        left: "50%",
        bottom: 16,
        transform: "translateX(-50%)",
        zIndex: 50,
        background: "transparent",
        width: "min(520px, 100% - 32px)",
        pointerEvents: "none", // låt viewern under få events
      }}
    >
      <Stack gap={8}>
        {React.Children.map(children, (child) =>
          child ? (
            <Box
              style={{
                pointerEvents: "auto", // men banners kan klickas
                borderRadius: 999,
                padding: "8px 12px",
              }}
            >
              {child}
            </Box>
          ) : null
        )}
      </Stack>
    </Box>
  );
};
